<template>
  <div class="home">
    <Header />
    <div class="content">
      <div class="main-banner">
        <img src="@/assets/PC/mainBanner.png" alt="" />
      </div>
      <Main />
      <div class="main-box">
        <div class="auto-box">
          <router-view></router-view>
        </div>
      </div>
    </div>
    <Footer class="end" />

    <!-- 中心运营位 -->
    <div class="modal-box" v-if="showModal && modalBanner.picturePc">
      <div class="img-box">
        <img
          :src="modalBanner.picturePc"
          alt=""
          @click="openUrl(modalBanner)"
        />
        <img
          class="close pointer"
          v-if="modalBanner.typeFlag === '0'"
          width="24"
          height="24"
          src="@/assets/PC/newclose.png"
          alt=""
          @click="showModal = false"
        />
      </div>
    </div>
    <!-- 底部运营位 -->
    <div class="foot-banner" v-if="showFootBanner && footBanner.picturePc">
      <div class="foot-banner-img-box">
        <img
          :src="footBanner.picturePc"
          class="foot-img"
          @click="openUrl(footBanner)"
          alt=""
        />
        <img
          class="foot-close pointer"
          v-if="footBanner.typeFlag === '0'"
          width="24"
          height="24"
          src="@/assets/PC/newclose.png"
          alt=""
          @click="showFootBanner = false"
        />
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, ref, onMounted } from "vue";
import Header from "@/components/PC/Header.vue";
import Footer from "@/components/PC/Footer.vue";
import Main from "@/components/PC/Main.vue";
import { queryAdvertOperationPushAll, addGgUserInfo } from "@/api/play.js";
export default defineComponent({
  name: "Home",

  components: {
    Header,
    Main,
    Footer,
  },

  setup() {
    let showModal = ref(false);
    let modalBanner = ref({
      picturePc: "",
      typeFlag: "", // 是否可关闭
    });
    let footBanner = ref({
      picturePc: "",
      typeFlag: "", // 是否可关闭
    });
    let showFootBanner = ref(false);
    const openUrl = (item) => {
      _advertPushUserAdd(item);
      if (item.urlPc) {
        window.open(item.urlPc);
      }
    };

    let _advertPushUserAdd = (item, relationType = 7, relationId = 0) => {
      let params = {
        advertId: item.id,
        advertMaterialId: item.advertMaterialId,
        advertPushId: item.advertPushId,
        relationType,
        relationId,
      };
      addGgUserInfo(params);
    };

    const _queryAdvertPushAll = (relationId = 0, relationType = 7) => {
      let params = {
        relationId,
        relationType, //1. 直播  2.视频  3.医邻官方首页 4. 医邻儿科首页 5.主题首页 6.课程
        flag: sessionStorage.getItem("OperatingPositionMain"),
      };
      queryAdvertOperationPushAll(params).then((res) => {
        // operation: 1-医邻官网banner 2-医邻儿科banner 3-通用弹窗 4-通用底部banner
        res.results.forEach((element) => {
          if (element.operation === "3") {
            showModal.value = true;
            sessionStorage.setItem("OperatingPositionMain", true);
            modalBanner.value = element;
          }
          if (element.operation === "4") {
            showFootBanner.value = true;
            footBanner.value = element;
            console.log(footBanner, "footBanner");
          }
        });
      });
    };
    onMounted(() => {
      _queryAdvertPushAll();
    });
    return {
      showModal,
      modalBanner,
      showFootBanner,
      _queryAdvertPushAll,
      footBanner,
      openUrl,
    };
  },
});
</script>
<style lang="less" scoped>
.home {
  display: flex;
  flex-direction: column;
  background: #f5f5fc;
  .main-banner {
    img {
      width: 100%;
      height: 101px;
    }
  }
}
.end {
  width: 100%;
  align-self: flex-end;
}
.content {
  width: 100%;
  display: flex;
  flex-direction: column;
  .main-box {
    margin-top: 12px;
    background: #ffffff;
  }
}

.foot-banner {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  .foot-banner-img-box {
    height: 150px;
    position: absolute;
    left: 50%;
    bottom: 0;
    transform: translateX(-50%);
  }
  .foot-img {
    height: 100%;
  }
  .foot-close {
    position: absolute;
    top: -44px;
    right: 0;
  }
}
.modal-box {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  z-index: 999;
  .img-box {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 450px;
    transform: translate(-50%, -50%);
    img {
      width: 450px;
    }
    .close {
      width: 23px;
      height: 23px;
      position: absolute;
      right: 0;
      top: -44px;
    }
  }
}
</style>
